import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {decodeDeeplink, generateUUID2, isDeepLink, isStringNullOrEmpty, removeHtmlTags} from "../../utils";
import {EVENT_FAVIRIATE_CHANGE, EVENT_REFRESH_FAVOR, IMPORT_FILE_MODE_IMPORTMODE} from "../../Const";
import {ipcInvoke} from "../../common/ipc";
import link from "@/components/EditorV2/Link";
import {updateLink} from "@model/link";
import {postMessage} from "@/common/event";
import {isSupportLink} from "@/Utility";
import {getNoteById, getProjectById} from "@model/note";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {loop, loopAllNodeAsync} from "@/TreeUtils";
import {
    isMindmapElement,
    isStickyNotesElement,
    isTextElement
} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {getCardById} from "@model/card";

const DialogAddLink = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [linkFavor,setLinkFavor] = useState({name:'',url:''});
    const txtNameRef = useRef(null);

    useEffect(()=>{
        document.body.addEventListener('keydown',onKeyDown);
        return ()=>{
            document.body.removeEventListener('keydown',onKeyDown);
        }
    })

    /**
     * 响应回车.
     * @param event
     */
    const onKeyDown = (event:any)=>{
        if (event.key == KEYS.ENTER){
            onConfirm();
        }
    }

    const onShowDialog = (link:any)=>{
        setIsShowDialog(true);
        if (link){
            setLinkFavor(link);
        }

        setTimeout(()=>{
            txtNameRef.current?.focus();
        },200)
    }


    const onConfirm = ()=>{
        if (!linkFavor.name) {
            message.destroy();
            message.error(t("PleaseEnterTitle"));
            return;
        }
        if (!linkFavor.url) {
            message.destroy();
            message.error(t("PleaseEnterLink"));
            return;
        }
        //保存...
        const newLinkFavor = {...linkFavor};
        if (!newLinkFavor.id) {
            newLinkFavor.id = generateUUID2();
        }
        newLinkFavor.isFavirated = 1;
        newLinkFavor.favirateTime = Date.now();
        newLinkFavor.type = 'linkFavor';
        if (isDeepLink(newLinkFavor.url) || isSupportLink(newLinkFavor.url)) {

        }else {
            if (!newLinkFavor.url.startsWith('http')) {
                newLinkFavor.url = 'https://'+newLinkFavor.url;
            }
        }
        updateLink(newLinkFavor).then(res=>{
            postMessage(EVENT_FAVIRIATE_CHANGE)
        });
        props.onCloseCallback();
    }

    return <Modal width={520} zIndex={2005} bodyStyle={{height: `auto`}}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t("Add link")}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            <span className={'mt-12'}>{t("Title")}</span>
            <input ref={txtNameRef} className={'input-border mt-10'} placeholder={t('Enter title')} value={linkFavor?.name} onInput={(e)=>{
                const newLink = {...linkFavor};
                newLink.name = e.currentTarget.value;
                setLinkFavor(newLink);
            }}/>

            <span className={'mt-18'}>{t("Link")}</span>
            <input className={'input-border mt-10'} placeholder={'https://'} value={linkFavor?.url}
                   onInput={(e)=>{
                const newLink = {...linkFavor};
                newLink.url = e.currentTarget.value;
                setLinkFavor(newLink);
            }} onPaste={async (event)=>{
                if (!linkFavor.name) {
                    //没有标题...
                    const szTxt = event.clipboardData.getData('text/plain');
                    if (isDeepLink(szTxt)) {
                        const newLink = {...linkFavor};
                        const deeplink = decodeDeeplink(szTxt);
                        let szName:any = '';
                        if (deeplink.type == 'project') {
                            const project:any = await getNoteById(deeplink.id,true,true);
                            if (project) {
                                if (deeplink.elementId) {
                                    let bFind = false;
                                    await loopAllNodeAsync(project.doc.canvas, async (node) => {
                                        if (!bFind && node.key == deeplink.childId){
                                            bFind = true;
                                            const element = node.drawJson?.elements?.find(p=>p.id == deeplink.elementId);
                                            if (element){
                                                //取元素的...
                                                if (isMindmapElement(element)) {
                                                    szName = removeHtmlTags(element.data?.data?.text)
                                                } else if (isStickyNotesElement(element)) {
                                                    szName = element.value;
                                                } else if (isTextElement(element)){
                                                    szName = element.originalText;
                                                }
                                                else{
                                                    const library = await getCardById(element.customData?.generationData?.id);
                                                    if (library){
                                                        szName = library.name;
                                                    }
                                                }
                                            }
                                        }
                                    })
                                }else if (deeplink.childId) {
                                    //是board
                                    loop(project.doc.canvas,deeplink.childId,(node, i, data, parent)=>{
                                        szName = node.title;
                                    })
                                }else {
                                    szName = project.name;
                                }
                            }
                        }else if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                            const library = await getCardById(deeplink.childId || deeplink.id);
                            if (library){
                                szName = library.title || library.name;
                            }
                        }

                        newLink.name = szName;
                        newLink.url = szTxt;
                        setLinkFavor(newLink);
                    }
                }
            }}/>

            <div className={'flex-center mt-32 mb-4'}>
                <Button
                    style={{height: '34px', minWidth: '120px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                    }}>{t("Cancel")}</Button>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        onConfirm();
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '120px'
                    }}
                    htmlType={"submit"}>{t("Save")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogAddLink;